import { v4 as uuid } from 'uuid';
import { PERMISSION_TO_TEXT } from '../../constants/permissions.constants';

export const ADMIN_CONTACT_SCHOOL_ORGANIZATIONS_RESOURCE = {
  key: 'ADMIN_CONTACT_SCHOOL_ORGANIZATIONS_RESOURCE',
  table: {
    title: 'Schoolorganisatie',
    defaultSort: 'name',
    dataLocation: '_embedded.static',
    searchParams: ['name'],
    disablePagination: true,
    fields: [
      { value: 'netName', label: 'Net', show: true, order: 0 },
      { value: 'managementName', label: 'Schoolbestuur', show: true, order: 1 },
      { value: 'communityName', label: 'Scholengemeenschap', show: true, order: 2 },
      { value: 'schoolName', label: 'School', show: true, order: 3 },
      { value: 'branchName', label: 'Vestiging', show: true, order: 4 },
      { value: 'function', label: 'Functie', show: true, order: 5 },
      { value: 'role', label: 'Rechten', show: true, order: 6 },
      { value: 'isApproved', label: 'Goedgekeurd', show: true, order: 7 }
    ],
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        id: data?.id || uuid(),
        role: PERMISSION_TO_TEXT?.[i?.role] ?? '',
        isApproved: i?.isApproved ? 'Ja' : 'Nee'
      }))
  }
};
